export enum PaybackTypeEnum {
  PROMO_CODES = 'promo-codes',
  REFERRAL_CODES = 'referral-codes',
  DEPOSIT_SKINS = 'deposit-skins',
}
